@if (!configError() && config()) {
  <div class="widget-host" [class.widget-host--right]="position() === 'right'" [class.widget-host--left]="position() === 'left'" [class.widget-host--mobile]="isMobile()">
    @if (isOpen() || embedded) {
      <div class="picker-panel">

        @if (view() === 'picker') {
          <div class="picker-panel__header" [style.background-color]="config()?.color">
            <glxy-avatar
              [name]="config()?.assistantName || config()?.name"
              [src]="config()?.assistantAvatarUrl"
              [width]="48"
              shape="circle"
            ></glxy-avatar>
            <div class="picker-panel__header-text">
              <span class="picker-panel__title">{{ config()?.name }}</span>
              <span class="picker-panel__subtitle">
                <span class="picker-panel__status-dot"></span>
                {{ 'WEBCHAT.MULTI_LOCATION.RESPOND_IMMEDIATELY' | translate }}
              </span>
            </div>
            @if (!embedded) {
              <button class="picker-panel__close" (click)="closeWidget()" [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.CLOSE_ARIA_LABEL' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            }
          </div>

          <div class="picker-panel__search">
            <glxy-form-field [showLabel]="false" prefixIcon="search" bottomSpacing="none">
              <input
                matInput
                type="search"
                [placeholder]="'WEBCHAT.MULTI_LOCATION.SEARCH_PLACEHOLDER' | translate"
                [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.SEARCH_ARIA_LABEL' | translate"
                (input)="onSearch($event)"
              />
            </glxy-form-field>
          </div>

          <div class="picker-panel__body">
            @if (isLoading()) {
              <div class="picker-panel__loading">
                <glxy-loading-spinner></glxy-loading-spinner>
              </div>
            } @else if (error()) {
              <div class="picker-panel__empty">
                <p>{{ 'WEBCHAT.MULTI_LOCATION.ERROR_GENERIC' | translate }}</p>
                <button mat-stroked-button (click)="retrySearch()">{{ 'WEBCHAT.MULTI_LOCATION.TRY_AGAIN' | translate }}</button>
              </div>
            } @else if (locations().length === 0) {
              <div class="picker-panel__empty">
                <p>{{ 'WEBCHAT.MULTI_LOCATION.NO_LOCATIONS' | translate }}</p>
              </div>
            } @else {
              @for (loc of locations(); track loc.namespace) {
                <button class="location-card" (click)="selectLocation(loc)">
                  <div class="location-card__text">
                    <span class="location-card__name">{{ loc.businessName }}</span>
                    @if (loc.address) {
                      <span class="location-card__address">{{ loc.address }}</span>
                    }
                  </div>
                  <mat-icon class="location-card__chevron">chevron_right</mat-icon>
                </button>
              }
            }
          </div>

          @if (hasPrev() || hasMore()) {
            <div class="picker-panel__pagination">
              <button
                mat-icon-button
                [disabled]="!hasPrev()"
                (click)="prevPage()"
                [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.PREV_PAGE_ARIA_LABEL' | translate"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="picker-panel__page-label">{{ 'WEBCHAT.MULTI_LOCATION.PAGE' | translate: { page: currentPage() } }}</span>
              <button
                mat-icon-button
                [disabled]="!hasMore()"
                (click)="nextPage()"
                [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.NEXT_PAGE_ARIA_LABEL' | translate"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }

          @if (config()?.showFooterContent) {
            <mat-divider></mat-divider>
            <div class="picker-panel__footer">
              @if (config()?.poweredByName) {
                @if (config()?.poweredByUrl) {
                  <a [href]="config()?.poweredByUrl" target="_blank" rel="noopener noreferrer" class="picker-panel__footer-link">
                    {{ 'WEBCHAT.MULTI_LOCATION.POWERED_BY' | translate: { name: config()?.poweredByName } }}
                  </a>
                } @else {
                  <span>{{ 'WEBCHAT.MULTI_LOCATION.POWERED_BY' | translate: { name: config()?.poweredByName } }}</span>
                }
              }
            </div>
          }
        }

        @if (view() === 'chat') {
          <div class="picker-panel__header" [style.background-color]="config()?.color">
            <button class="picker-panel__close" (click)="goBack()" [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.BACK_ARIA_LABEL' | translate">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
              </svg>
            </button>
            <glxy-avatar
              [name]="config()?.assistantName || selectedLocation()?.businessName"
              [src]="config()?.assistantAvatarUrl"
              [width]="40"
              shape="circle"
            ></glxy-avatar>
            <div class="picker-panel__header-text">
              <span class="picker-panel__title">{{ config()?.name }}</span>
              <span class="picker-panel__subtitle">{{ 'WEBCHAT.MULTI_LOCATION.CHATTING_WITH' | translate: { name: selectedLocation()?.businessName } }}</span>
            </div>
            <button class="picker-panel__close" (click)="closeWidget()" [attr.aria-label]="'WEBCHAT.MULTI_LOCATION.CLOSE_ARIA_LABEL' | translate">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </div>
          <div class="chat-body">
            <div class="chat-body__inset">
            <webchat-box
              [embedded]="true"
              [fullView]="true"
              [hideEmptyState]="true"
              [currentParticipantId]="currentParticipantId()"
              [messageGroups]="[]"
              [messages]="[]"
              [webchatColor]="config()?.color"
              [webchatTextColor]="config()?.textColor"
              [webchatAccentColor]="config()?.accentColor"
              [webchatAccentTextColor]="config()?.accentTextColor"
              [position]="position()"
              [assistantName]="selectedLocation()?.businessName"
              [assistantAvatarUrl]="config()?.assistantAvatarUrl"
              [welcomeMessage]="config()?.welcomeMessage"
              [showFooterContent]="config()?.showFooterContent"
              [poweredBy]="{ name: config()?.poweredByName, url: config()?.poweredByUrl }"
            ></webchat-box>
            </div>
          </div>
        }

      </div>
    }
    @if (!embedded && !(isMobile() && isOpen())) {
      <webchat-button
        (clicked)="isOpen() ? closeWidget() : openWidget()"
        [position]="position()"
        [backgroundColor]="config()?.color"
        [iconColor]="config()?.textColor === 'light' ? 'light' : 'dark'"
      ></webchat-button>
    }
  </div>
}
